import ApiService from "@/core/services/api.service";

//Actions
export const FETCH_AI_INVOICE_ACCOUNTING_VALUES =
  "fetchAiInvoiceAccountingValues";
export const FETCH_AI_INVOICE_ACCOUNTING_VALUE =
  "fetchAiInvoiceAccountingValue";
export const SAVE_AI_INVOICE_ACCOUNTING_VALUE = "saveAiInvoiceAccountingValue";
export const UPDATE_AI_INVOICE_ACCOUNTING_VALUE =
  "updateAiInvoiceAccountingValue";
export const DELETE_AI_INVOICE_ACCOUNTING_VALUE =
  "deleteAiInvoiceAccountingValue";

//Mutations
export const SET_ERROR = "setError";
export const SET_LOADING = "setLoadingAiInvoiceAccountingValue";
export const SET_AI_INVOICE_ACCOUNTING_VALUES = "setAiInvoiceAccountingValues";

const state = {
  ai_invoice_accounting_values_errors: [],
  ai_invoice_accounting_values: [],
  isLoadingAiInvoiceAccountingValue: false
};

const getters = {
  isLoadingAiInvoiceAccountingValue() {
    return state.isLoadingAiInvoiceAccountingValue;
  },
  getAiInvoiceAccountingValues() {
    return state.ai_invoice_accounting_values;
  }
};

const actions = {
  [FETCH_AI_INVOICE_ACCOUNTING_VALUES](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("ai-invoice-accounting-values" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_AI_INVOICE_ACCOUNTING_VALUE](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("ai-invoice-accounting-values", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [SAVE_AI_INVOICE_ACCOUNTING_VALUE](context, payload) {
    context.commit(SET_LOADING, true);
    const form = payload;
    return new Promise((resolve, reject) => {
      ApiService.post("ai-invoice-accounting-values", form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [UPDATE_AI_INVOICE_ACCOUNTING_VALUE](context, params) {
    context.commit(SET_LOADING, true);
    const form = params.payload;
    const id = params.id;
    return new Promise((resolve, reject) => {
      ApiService.update("ai-invoice-accounting-values", id, form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [DELETE_AI_INVOICE_ACCOUNTING_VALUE](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.delete("ai-invoice-accounting-values", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.isLoadingAiInvoiceAccountingValue = false;
    if (Array.isArray(errors)) {
      state.ai_invoice_accounting_values_errors = errors;
    } else {
      state.ai_invoice_accounting_values_errors = [errors];
    }
  },
  [SET_LOADING](state, value) {
    state.isLoadingAiInvoiceAccountingValue = value;
  },
  [SET_AI_INVOICE_ACCOUNTING_VALUES](state, data) {
    state.isLoadingAiInvoiceAccountingValue = false;
    state.ai_invoice_accounting_values = data.data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
